/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopSourcesDTO = {
    id?: string;
    name?: string;
    address?: string;
    identificationNumber?: string;
    phoneNumber?: string;
    line?: string;
    email?: string;
    vatType?: ShopSourcesDTO.vatType;
    note?: string;
    shopId?: string;
    active?: boolean;
};
export namespace ShopSourcesDTO {
    export enum vatType {
        VAT = 'VAT',
        NON_VAT = 'NON_VAT',
    }
}

